<template>
  <div>
    <div class="card mb-4 pt-2">
      <div class="card-body p-4 p-md-5">
        <p class="description">
          Prosím pripravte si na overenie Váš doklad totožnosti(občiansky preukaz / pas) a povoľte zariadeniu prístup ku kamere. Po dokončení procesu verifikácie stlačte tlačidlo <strong>Dokončiť</strong> (v pravom dolnom rohu).
        </p>
        <div class="text-center">
          <a href="https://app.veriface.eu/?ot=WLEt2VMHw3doYXYR" class="btn btn-outline-highlighted text-center" target="_blank">Spustiť overenie</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { token } from "@/store/modules/onboarding";

export default {
  name: "verification",
  created() {
    this.$emit("can-continue", { value: true });
  },
  methods: {
    submit() {
      this.$parent.$parent.loading = true;
      this.$store
        .dispatch("onboarding/saveVerification")
        .then(() => {
          this.$parent.$parent.loading = false;
          this.$parent.$parent.nextStep();
        })
        .catch(() => {
          this.$parent.$parent.loading = false;
        });
    }
  }
};
</script>
